// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Analytics } from '@trello/atlassian-analytics';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import template from 'app/scripts/views/templates/power_ups_voting_prefs';

class VotingSettingsView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'voting settings';

    this.prototype.events = {
      'click .js-voting-select:not(.disabled)': 'selectPerm',
      'click .js-vote-count-select:not(.disabled)': 'hideVotes',
    };
  }

  initialize() {
    return this.listenTo(this.model, { 'change:prefs': this.render });
  }

  render() {
    this.$el.html(
      template({
        canChange: this.model.editable(),
        canSetObservers: this.model
          .getOrganization()
          ?.isFeatureEnabled('observers'),
        canSetOrganization: this.model.hasOrganization(),
        canSetPublic: this.model.isPublic(),
        votingMode: this.model.getPref('voting'),
        hideVotes: this.model.getPref('hideVotes'),
        isPrivate: this.model.isPrivate(),
      }),
    );

    return this;
  }

  selectPerm(e) {
    stopPropagationAndPreventDefault(e);
    const traceId = Analytics.startTask({
      taskName: 'edit-plugin/voting',
      source: 'votingSettingsInlineDialog',
    });
    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target).closest('.js-voting-select');
    const setting = $target.attr('name');
    this.model.setPrefWithTracing('voting', setting, {
      taskName: 'edit-plugin/voting',
      source: 'votingSettingsInlineDialog',
      traceId,
      next: (_err, board) => {
        if (board) {
          Analytics.sendUpdatedBoardFieldEvent({
            field: 'votingPref',
            value: setting,
            source: 'votingSettingsInlineDialog',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            },
            attributes: {
              previous: this.model.getPref('voting'),
              taskId: traceId,
            },
          });
        }
      },
    });
  }

  hideVotes(e) {
    stopPropagationAndPreventDefault(e);
    const traceId = Analytics.startTask({
      taskName: 'edit-plugin/voting',
      source: 'votingSettingsInlineDialog',
    });

    this.model.setPrefWithTracing(
      'hideVotes',
      !this.model.getPref('hideVotes'),
      {
        taskName: 'edit-board/voting',
        source: 'votingSettingsInlineDialog',
        traceId,
        next: (_err, board) => {
          if (board) {
            Analytics.sendUpdatedBoardFieldEvent({
              field: 'hideVotesPref',
              value: this.model.getPref('hideVotes'),
              source: 'votingSettingsInlineDialog',
              attributes: {
                taskId: traceId,
              },
              containers: {
                board: {
                  id: this.model.id,
                },
                organization: {
                  id: this.model.getOrganization()?.id,
                },
              },
            });
          }
        },
      },
    );
  }
}

VotingSettingsView.initClass();
export { VotingSettingsView };
